import React, { useContext, useState } from 'react';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const SnackBarContext = React.createContext();

export function useSnackBar() {
  return useContext(SnackBarContext);
}

export function SnackBarProvider({ children }) {
  const [message, setMessage] = useState('');
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [severity, setSeverity] = useState('success');

  const value = {
    setMessage,
    setOpenSnackBar,
    setSeverity,
  };

  const onClose = () => {
    setOpenSnackBar(false);
  };

  return (
    <SnackBarContext.Provider value={value}>
      <Snackbar open={openSnackBar} autoHideDuration={5000} onClose={onClose}>
        <MuiAlert onClose={onClose} severity={severity}>
          {message}
        </MuiAlert>
      </Snackbar>
      {children}
    </SnackBarContext.Provider>
  );
}
